import { usePushNotifications } from "@web/hooks/usePushNotifications";
import { useEffect } from "react";

export function PushNotificationInit() {
  const { status, subscribed, subscribe, checkSubscription } = usePushNotifications();

  useEffect(() => {
    checkSubscription();
  }, [checkSubscription]);

  useEffect(() => {
    if (status === "granted" && !subscribed) {
      subscribe();
    }
  }, [status, subscribed, subscribe]);

  return null;
}
